import React from 'react'
import { Box, Typography } from '@mui/material'

type Props = {
  children: React.ReactNode
  /** Action optionnelle alignee a droite (ex: lien « Voir tout ») */
  action?: React.ReactNode
}

/**
 * Titre de section unifie pour la home : centre, gras, meme taille partout.
 * L'action eventuelle reste a droite sans decaler le titre du centre.
 */
const SectionTitle: React.FC<Props> = ({ children, action }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: '1fr auto 1fr',
      alignItems: 'center',
      columnGap: 1,
      width: '100%',
      mb: 2,
    }}
  >
    <Box />
    <Typography
      variant="subtitle2"
      sx={{
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: { xs: '20px', md: '24px' },
      }}
    >
      {children}
    </Typography>
    <Box sx={{ justifySelf: 'end' }}>{action}</Box>
  </Box>
)

export default SectionTitle
